module.exports = require("get-pkg-prop");